import React from "react";
const ItemSummaryWithPhotoWidget = ({ data }) => {
    return (
        <div className="flex justify-between items-center space-x-2">
            <div className="flex items-center">
                <img src={data.photoUrl} className="w-24 h-16 rounded-md" />
                <span className="font-semibold text-sm pl-2"
                style={{
                    "display": "-webkit-box",
                    "-webkit-box-orient": "vertical",
                    "-webkit-line-clamp": "2",
                    "overflow": "hidden",
                    "text-overflow": "ellipsis"
                    }}
                >
                    {data.title}
                </span>
            </div>
            <span className="font-semibold text-skin-dark text-lg pl-2">{data.price}</span>
        </div>
    );
};
export default ItemSummaryWithPhotoWidget;
